if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      // this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    empty() {
      const list = document.querySelector('pickup-availability-list');
      list.innerHTML = "<p>Unavailable</p>"
    }

    renderPreview(sectionInnerHTML) {
      const list = document.querySelector('pickup-availability-list');
      const listContainer = document.getElementById('inStoreAvailability');
      if (list) list.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      listContainer.appendChild(sectionInnerHTML.querySelector('pickup-availability-list'));

      this.querySelector('button').addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-list').show(evt.target);
      });
    }
    
  });
}

if (!customElements.get('pickup-availability-list')) {
  customElements.define('pickup-availability-list', class PickupAvailabilityList extends HTMLElement {
    constructor() {
      super();

    }

  });
}
